import React from "react";
import {asHHCC} from "./Week";
import BasicBadge from "@components/BasicBadge";

export const BadgeHHCCLav: React.FC<{ hPrev: number, hLav: number }> = ({hPrev, hLav}) => {
    const bg = hLav < hPrev ? 'bg-hhMancanti' : hLav > hPrev ? 'bg-hhEccedenti' : '';
    const text = hLav < hPrev ? 'text-white' : hLav > hPrev ? 'text-white' : '';
    return <BasicBadge as={"div"}
                       label={asHHCC(hLav)} type={"custom"}
                       containerClass={`m-auto text-center text-xs max-w-fit min-w-[60px] min-h-[20px]`}
                       customStyle={{bg, text}}></BasicBadge>;
}